import { render, staticRenderFns } from "./customer-statistic.vue?vue&type=template&id=56cf5354&scoped=true"
import script from "./customer-statistic.vue?vue&type=script&lang=ts"
export * from "./customer-statistic.vue?vue&type=script&lang=ts"
import style0 from "./customer-statistic.vue?vue&type=style&index=0&id=56cf5354&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cf5354",
  null
  
)

export default component.exports